@if (isVisible()) {
  <div class="content" [class.dark]="themeName() === 'dark'">
    <div class="title-wrap">
      @if (variant() === 'ai') {
        <div class="icon-wrap">
          <rt-ai-logo size="medium" />
        </div>
      } @else if (iconName(); as name) {
        <div class="icon-wrap">
          <rt-icon [name]="name" [colorToken]="iconColor()" />
        </div>
      }
      <div class="text-container">
        @if (textTemplate(); as template) {
          <ng-container
            [ngTemplateOutlet]="template"
            [ngTemplateOutletContext]="{
              description: description(),
              title: title(),
            }"
          />
        } @else {
          <rt-heading variant="subheading dark normal">{{ description() }}</rt-heading>
          <rt-heading variant="heading large">{{ title() }}</rt-heading>
        }
      </div>
    </div>
    <div class="cta-container">
      <rt-button (click)="ctaClick.emit()" variant="tertiary">
        <span>{{ ctaText() }}</span>
      </rt-button>
      @if (dismissible()) {
        <rt-icon-button (click)="dismiss()" variant="plain" iconName="close" />
      }
    </div>
  </div>
}
